$('.sidebar__item--drop').click(function(){
  $(this).addClass('sidebar__item--hide');
   $('.sidebar__hidden').slideToggle(300);
	// $('.sidebar__hidden').addClass('sidebar__hidden--show');
});

$('.sidebar__item--under').click(function () {
  $(this).find(".sidebar__drop").slideToggle(300);
});
